import { render, staticRenderFns } from "./ocrUpdModify.vue?vue&type=template&id=96e444c6"
import script from "./ocrUpdModify.vue?vue&type=script&lang=js"
export * from "./ocrUpdModify.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdModify.vue?vue&type=style&index=0&id=96e444c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports